import { normalizeValue } from '@dte/otw-utils-core/src/strings/normalizeValue';
import { ValidationError } from '@dte/otw-utils-validation/src/ValidationError';
import isLength from 'validator/es/lib/isLength';

export function validateRequiredString(
	name: string,
	value: string | undefined,
	minLength?: number,
	// Put a limit on input strings
	maxLength = 100,
): string {
	const normalized = normalizeValue(value);

	if (!normalized) {
		throw new ValidationError(`Invalid value: ${name} is required`);
	}

	if (!isLength(normalized, { min: minLength, max: maxLength })) {
		throw new ValidationError(
			`Invalid value: ${name} must be between ${minLength} and ${maxLength} characters long`,
		);
	}

	return normalized;
}

export function validateString(
	name: string,
	value: string | undefined,
	minLength?: number,
	// Put a limit on input strings
	maxLength = 100,
	required = true,
): string | undefined {
	if (required) {
		return validateRequiredString(name, value, minLength, maxLength);
	}

	const normalized = normalizeValue(value);
	if (!normalized) {
		return normalized;
	}

	if (!isLength(normalized, { min: minLength, max: maxLength })) {
		throw new ValidationError(
			`Invalid value: ${name} must be between ${minLength} and ${maxLength} characters long`,
		);
	}

	return normalized;
}

export function isValidStringLength(
	value: string,
	minLength?: number,
	// Put a default limit on input strings
	maxLength = 100,
	required = false,
): boolean {
	try {
		validateString('value', value, minLength, maxLength, required);
		return true;
	} catch {
		return false;
	}
}
